import { apiFetch } from './apiFetch';

export const getAllCohorts = ({ queryKey }) => {
  const [, { page = 1, search, filter, count = 10 }] = queryKey;

  const url = new URL(
    `/api/v2/cohorts`,
    window.location.origin
  );

  const params = {
    page,
    count,
    ...(search && { search }),
    ...(filter &&
      Object.keys(filter).length > 0 && { filter: JSON.stringify(filter) }),
  };

  url.search = new URLSearchParams(params).toString();
  return apiFetch({
    url: url.toString(),
    method: 'GET',
  });
}

export const getCohort = ({ cohortId }) => {
  apiFetch({
    url: '/api/v2/cohorts',
    method: 'POST',
    body: { cohorts: { id: cohortId } },
  });
}

export const getCohorts = () => {
  apiFetch({
    url: '/api/v2/cohorts/get_cohorts',
    method: 'GET',
  });
}
